module.exports = __webpack_public_path__ + "static/media/180001.cc51fa0e.png";